var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar-content"},[_c('div',{staticClass:"progress-bar-content-base"},[_c('div',{staticClass:"progress-bar-content-base-progress",style:({ width: `${_vm.percentage}%` })})]),_c('p',{staticClass:"progress-bar-content-value"},[_vm._v(_vm._s(_vm.percentage)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }